// import { useState } from "react";

// import Box from "@mui/material/Box";
// import Stack from "@mui/material/Stack";
// import Tab from "@mui/material/Tab";
// import Tabs from "@mui/material/Tabs";

// import Typography from "@mui/material/Typography";
// import Reports from "./Reports/Reports";
// import StoreTidMaster from "./StoreTidMaster/StoreTidMaster";
// import FileUpload from "./FileUpload/FileUpload";
// import PaymentTypeQueries from "./PaymentTypeQueries/PaymentTypeQueries";
// import Summary from "./Summary/Summary.js";
// import UploadHistory from "./UploadHistory/UploadHistory";

// //for tab section
// function a11yProps(index) {
// 	return {
// 		id: `simple-tab-${index}`,
// 		"aria-controls": `simple-tabpanel-${index}`,
// 	};
// }

// const tabStyle = { textTransform: "capitalize", fontSize: "16px", minWidth: "170px" };

// const POSReco = () => {
// 	const [tab, setTab] = useState(0);

// 	const handleTabChange = (event, newValue) => {
// 		setTab(newValue);
// 	};

// 	return (
// 		<Stack width="90vw" maxWidth="1900px" margin="auto" spacing={2}>
// 			<Typography variant="h4" width="100%" pt={4} pb={2}>
// 				POS COLLECTION RECONCILIATION
// 			</Typography>
// 			<Box height="450px">
// 				<Tabs
// 					value={tab}
// 					onChange={handleTabChange}
// 					aria-label="basic tabs example"
// 					sx={{ borderBottom: 1, borderColor: "divider", mb: 2 }}>
// 					<Tab sx={tabStyle} label="STORE TID MASTER" {...a11yProps(0)} />
// 					<Tab sx={tabStyle} label="FILE UPLOAD" {...a11yProps(1)} />
// 					{/* <Tab sx={tabStyle} label="PAYMENT TYPES" {...a11yProps(2)} /> */}
// 					<Tab sx={tabStyle} label="SUMMARY" {...a11yProps(2)} />
// 					<Tab sx={tabStyle} label="UPLOAD HISTORY" {...a11yProps(3)} />
// 					<Tab sx={tabStyle} label="REPORTS" {...a11yProps(4)} />
// 				</Tabs>
// 				<Box display={tab === 0 ? "block" : "none "}>
// 					<StoreTidMaster />
// 				</Box>
// 				<Box display={tab === 2 ? "block" : "none"}>
// 					<Summary />
// 				</Box>
// 				<Box display={tab === 1 ? "block" : "none "}>
// 					<FileUpload />
// 				</Box>
// 				<Box display={tab === 3 ? "block" : "none "}>
// 					<UploadHistory />
// 				</Box>
// 				{/* <Box display={tab === 2 ? "block" : "none "}>
// 					<PaymentTypeQueries />
// 				</Box> */}

// 				<Box display={tab === 4 ? "block" : "none"}>
// 					<Reports />
// 				</Box>
// 			</Box>
// 		</Stack>
// 	);
// };

// export default POSReco;

import ArrowBackRounded from "@mui/icons-material/ArrowBackRounded";
import IconButton from "@mui/material/IconButton";
import StoreTidMaster from "./StoreTidMaster/StoreTidMaster";
import Box from "@mui/material/Box";
// import Summary from "./Summary/Summary.js";
import Typography from "@mui/material/Typography";
import { useNavigate, useOutletContext } from "react-router-dom";
import { posDashboardSideNavList } from "./data";
import { CustomLinearProgress } from "components/ReusableComponents/CustomLinearProgress/CustomLinearProgress";
import RareBoxLogo from "Logos/RareBoxLogo";
import { useEffect, useState } from "react";
import { services, rootProtectedPath } from "data/authData";
import { Breadcrumbs } from "@mui/material";
import { grey } from "@mui/material/colors";
import { PosRecoState } from "context/PosRecoContext";
import { AuthState } from "context/AuthContext";
import { GlobalState } from "context/GlobalContext";
import BankStatementSummary from "./Summary/Summary.js";
import Summary from "./Summary/Summary.js";

export const createSessionData = ({ email, session_type = "report", name = "" }) => {
	const data = {
		action: "session_create",
		user_id: email,
		session_type: session_type,
		name: name,
	};
	return data;
};

const PosReco = () => {
	const [currentPath, service] = useOutletContext();
	const [serviceDisplayname, setServiceDisplayName] = useState();
	const { reportLoading, socket, sessionData, setService, setSessionData } = PosRecoState();
	const { setSnackBarOpen, setSnackBar, snackBar, LoadingOpen, setLoadingOpen, getAppCache, addToAppCache } = GlobalState();
	const { user } = AuthState();

	useEffect(() => {
		setService(service);
		const url = window.location.pathname;
		console.log(url, url?.split(`/${rootProtectedPath}/${services.pos_reco.path.split("/")[0]}/`)?.[1], "sdjfbzdn,");
		setServiceDisplayName(url?.split(`/${rootProtectedPath}/${services.pos_reco.path.split("/")[0]}/`)?.[1] ?? service.name);
	}, [service]);
	const navigate = useNavigate();

	const tabComponents = {
		[posDashboardSideNavList.HOME.key]: {
			...posDashboardSideNavList.HOME,
			component: <Summary />,
		},

		[posDashboardSideNavList.STORE_MASTER.key]: {
			...posDashboardSideNavList.STORE_MASTER,
			component: <StoreTidMaster />,
		},
	};

	return (
		<Box sx={{ width: "100%", p: 1, pt: 0, boxSizing: "border-box" }}>
			<Box display="flex" alignItems="center" columnGap={1}>
				<IconButton onClick={() => navigate(-1)}>
					<ArrowBackRounded />
				</IconButton>
				<Breadcrumbs>
					{serviceDisplayname
						?.split("/")
						.reduce((acc, row, i, arr) => {
							if (i !== arr.length - 1)
								acc.push(
									<Typography sx={{ color: grey[600] }} variant="h6" fontSize={18} textTransform="capitalize">
										{row.toLowerCase().split("_")?.join(" ")}
									</Typography>
								);
							return acc;
						}, [])
						.map((row) => row)}
					<Typography sx={{ color: "text.primary" }} variant="h6" fontSize={18} textTransform="capitalize">
						{service.name}
					</Typography>
				</Breadcrumbs>
				{/* <Typography variant="h5">{service?.name}</Typography> */}
			</Box>

			<Box
				width="100%"
				height="100%"
				display="flex"
				alignItems="center"
				justifyContent="center"
				sx={{ display: reportLoading ? "block" : "none" }}>
				<div
					style={{
						width: "200px",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%,-50%)",
					}}>
					<RareBoxLogo />
					<CustomLinearProgress />
				</div>
			</Box>
			<Box
				width="100%"
				height="100%"
				display="flex"
				alignItems="center"
				justifyContent="center"
				sx={{ display: reportLoading ? "none" : "block" }}>
				{tabComponents?.[currentPath]?.component}
			</Box>
		</Box>
	);
};

export default PosReco;
